export const WARNING_SINGLE =
  'This invoice has not been synced to Stripe and does not include a payment link.';
export const WARNING_MULTIPLE =
  'Some invoices have not been synced to Stripe and do not include payment links.';
